import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { MoodleConnectDialogComponent } from '../../components/dialogs/moodle-connect-dialog/moodle-connect-dialog.component';

@Component({
  selector: 'app-integrations',
  templateUrl: './integrations.component.html',
  styleUrl: './integrations.component.scss',
})
export class IntegrationsComponent implements OnInit {
  cardGroups = [
    {
      group: 'custom',
      labelKey: 'components.integrationsCards.categories.custom',
      cards: [
        {
          title: 'Browser',
          description: 'components.integrationsCards.webrowser',
          image: '/assets/images/integrations/webbrowser.svg',
          link: 'webbrowser',
        },
      ],
    },
    {
      // Der universelle Weg: eine LTI-1.3-Verbindung funktioniert mit jedem
      // LMS, das den Standard spricht. Hier wird nur verbunden — Kurs- und
      // Lernstandsdaten kommen aus der Gruppe darunter, und zwar nur für die
      // Plattformen, für die wir dafür einen eigenen Weg haben.
      group: 'lms_lti',
      labelKey: 'components.integrationsCards.categories.lmsLti',
      cards: [
        {
          title: 'LTI 1.3',
          description: 'components.integrationsCards.lti',
          image: '/assets/images/integrations/lti.svg',
          link: 'lti',
        },
      ],
    },
    {
      // Tiefe Anbindung: hier fließen Kurse, Personen und Lernstände. Setzt
      // die LTI-Verbindung aus der Gruppe darüber voraus (ILIAS) oder ein
      // eigenes Plugin (Moodle).
      group: 'lms_sync',
      labelKey: 'components.integrationsCards.categories.lmsSync',
      cards: [
        {
          title: 'Moodle Plugin',
          description: 'components.integrationsCards.moodlePlugin',
          image: '/assets/images/integrations/moodle.jpg',
          link: 'https://moodle.org/plugins/block_alphabees',
        },
        {
          title: 'Moodle Sync',
          description: 'components.integrationsCards.moodleSync',
          image: '/assets/images/integrations/moodle.jpg',
          link: 'moodle',
        },
        {
          title: 'ILIAS',
          description: 'components.integrationsCards.ilias',
          image: '/assets/images/integrations/ilias.png',
          link: 'ilias',
        },
        {
          title: 'OPEN edX',
          description: 'components.integrationsCards.openEdx',
          image: '/assets/images/integrations/open-edx.png',
          link: '',
        },
      ],
    },
    {
      group: 'documents',
      labelKey: 'components.integrationsCards.categories.documents',
      cards: [
        {
          title: 'Google Drive',
          description: 'components.integrationsCards.googleDrive',
          image: '/assets/images/integrations/google-drive.svg',
          link: 'google_drive',
        },
        {
          title: 'Dropbox',
          description: 'components.integrationsCards.dropbox',
          image: '/assets/images/integrations/dropbox.svg',
          link: 'dropbox',
        },
        {
          title: 'SharePoint',
          description: 'components.integrationsCards.sharepoint',
          image: '/assets/images/integrations/sharepoint.svg',
          link: 'sharepoint',
        },
      ],
    },
    {
      group: 'collaboration',
      labelKey: 'components.integrationsCards.categories.collaboration',
      cards: [
        {
          title: 'Microsoft Teams',
          description: 'components.integrationsCards.teams',
          image: '/assets/images/integrations/ms-teams.png',
          link: '',
        },
        {
          title: 'Slack',
          description: 'components.integrationsCards.slack',
          image: '/assets/images/integrations/slack.svg',
          link: '',
        },
      ],
    },
    {
      group: 'messenger',
      labelKey: 'components.integrationsCards.categories.messenger',
      cards: [
        {
          title: 'WhatsApp',
          description: 'components.integrationsCards.whatsapp',
          image: '/assets/images/integrations/whatsapp.webp',
          link: '',
        },
        {
          title: 'Telegram',
          description: 'components.integrationsCards.telegram',
          image: '/assets/images/integrations/telegram.webp',
          link: '',
        },
      ],
    },
  ];

  constructor(
    private route: ActivatedRoute,
    private dialogService: NbDialogService,
    private toastr: NbToastrService,
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['connected']) {
        const provider = (params['connected'] as string).replace(/_/g, ' ');
        this.toastr.success(
          `${provider} erfolgreich verbunden.`,
          'Verbunden!'
        );
      }
      if (params['error']) {
        this.toastr.danger(
          'Verbindung fehlgeschlagen. Bitte versuche es erneut.',
          'Fehler'
        );
      }
      if (params['open'] === 'moodle') {
        this.dialogService.open(MoodleConnectDialogComponent, {
          hasScroll: true,
          closeOnBackdropClick: true,
        });
      }
    });
  }
}
